import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FormatDriverTypePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatDriverType',
})
export class FormatDriverTypePipe implements PipeTransform {
  /**
   * Takes a job's drivertype value and displays in a human-readable format
   */
  transform(value: string, ...args) {
    let driverTypes = {
      studentRecentGrad: 'Student / Recent Graduate',
      soloCompany: 'Solo Company Driver',
      soloLease: 'Solo Lease Purchase',
      soloOwner: 'Solo Owner Operator',
      teamCompany: 'Team Company Driver',
      teamLease: 'Team Lease Purchase',
      teamOwner: 'Team Owner Operator',
    };
    return driverTypes[value] || 'Call to Discuss';
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-driver-type/format-driver-type.ts